import { graphql } from '@/generated/gql';

export const INTAKE_DISCARD_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeDiscard($data: SvbrgChatSessionInput!) {
    sevenbridges {
      chatSession {
        discard(data: $data) {
          createdAt
          id
          status
        }
      }
    }
  }
`);

export const INTAKE_CANCEL_MUTATION = graphql(/* GraphQL */ `
  mutation IntakeCancel($data: SvbrgChatSessionInput!) {
    sevenbridges {
      chatSession {
        cancel(data: $data) {
          createdAt
          id
          status
        }
      }
    }
  }
`);
